export { default } from './PMCLogo';
